import React from 'react';
import DidYouKnow from '../Personas/show/DidYouKnow'
import Essentials from '../Personas/show/Essentials'
import CitiesBreakdown from '../Personas/show/CitiesBreakdown'
import Overview from '../Personas/show/Overview'
import Universe from '../Personas/show/Universe'

const Persona = ({persona}) => (
  <React.Fragment>
    <Universe essentialPhotos={persona.images.filter(image => image.name === 'essentials')} />

    <Overview
      dataBrand={persona.insights.find(insight => insight.question_code === 'q2155').answers}
      dataFollowedOn={persona.insights.find(insight => insight.question_code === 'q48').answers}
      dataTime={persona.insights.find(insight => insight.question_code === 'q27le').answers}
    />

    {persona.payed &&
    <React.Fragment>

      <TimeSpent data={persona.insights.find(insight => insight.question_code === 'q27le').answers} />

      <CitiesBreakdown data={persona.insights.find(insight => insight.question_code === 'q48').answers} />

      <BrandDiscovery data={persona.insights.find(insight => insight.question_code === 'q2155').answers} />

    </React.Fragment>
    }

    <Essentials
      limitedView={!persona.payed}
      attitude={persona.insights.find(insight => insight.question_code === 'r10')}
      onlineInterests={persona.insights.find(insight => insight.question_code === 'q126d2')}
      onlinePurchases={persona.insights.find(insight => insight.question_code === 'q85b1')}
    />

    <Interest
      limitedView={!persona.payed}
      saving={persona.insights.find(insight => insight.question_code === 'q3d')}
      interests={persona.insights.find(insight => insight.question_code === 'q3181c')}
      homeLifestyle={persona.insights.find(insight => insight.question_code === 'q3181e')}
    />

    <MediaTouchpoint
      limitedView={!persona.payed}
      secondScreenActivity={persona.insights.find(insight => insight.question_code === 'gwi-ext.q120bnew')}
      brandDiscovery={persona.insights.find(insight => insight.question_code === 'q2155')}
      socialMedia={persona.insights.find(insight => insight.question_code === 'q303new')}
      pcOnlineActivity={persona.insights.find(insight => insight.question_code === 'r4154new,2')}
      mobileOnlineActivity={persona.insights.find(insight => insight.question_code === 'r4154new,3')}
      brandInteraction={persona.insights.find(insight => insight.question_code === 'q2157')}
      adBlockngMotivation={persona.insights.find(insight => insight.question_code === 'q1161')}
    />

    <DidYouKnow
      limitedView={!persona.payed}
      country={persona.audience.country}
      creationDate={persona.created_at}
      trends={persona.trends}
      adBlockers={persona.insights.find(insight => insight.question_code === 'q2173')}
    />
  </React.Fragment>
);

export default Persona